var exports = {
  "kL": "VoiceControlBar.module__container___UzMzMz",
  "UD": "VoiceControlBar.module__buttonContainer___UzMzMz",
  "x6": "VoiceControlBar.module__button___UzMzMz",
  "QV": "VoiceControlBar.module__buttonMuted___UzMzMz",
  "rp": "VoiceControlBar.module__buttonUnmuted___UzMzMz",
  "Jt": "VoiceControlBar.module__buttonDeafened___UzMzMz",
  "Zj": "VoiceControlBar.module__buttonCameraOn___UzMzMz",
  "PQ": "VoiceControlBar.module__buttonCameraOff___UzMzMz",
  "bt": "VoiceControlBar.module__buttonScreenShareOn___UzMzMz",
  "fB": "VoiceControlBar.module__buttonScreenShareOff___UzMzMz",
  "_p": "VoiceControlBar.module__buttonMoreOptions___UzMzMz",
  "Zt": "VoiceControlBar.module__buttonDisconnect___UzMzMz",
  "Q1": "VoiceControlBar.module__buttonSeparator___UzMzMz",
  "Se": "VoiceControlBar.module__settingsButton___UzMzMz",
  "on": "VoiceControlBar.module__stopWatchingButton___UzMzMz",
  "Kk": "VoiceControlBar.module__icon___UzMzMz",
  "Bx": "VoiceControlBar.module__iconSmall___UzMzMz",
};

module.exports = exports;
